var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-body customers-wrapper customer-list"},[_c('div',[_c('customer-topic-table')],1),_c('div',[_c('customer-feedback-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }